import { render } from "./Maintenance.vue?vue&type=template&id=a1d46134&scoped=true"
const script = {}

import "./Maintenance.vue?vue&type=style&index=0&id=a1d46134&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d46134"]])

export default __exports__